// export constants that we use in the rest of the program to avoid working with strings.
export const getAdsProviders = "getAdsProviders"
export const getAdsColumnTypes = "getAdsColumnTypes"
export const getAdsMeasures = "getAdsMeasures"
export const getAdsBuyingAgencies = "getAdsBuyingAgencies"
export const getAdsAdvertisers = "getAdsAdvertisers"
export const getAdsProducts = "getAdsProducts"
export const executeAdsQuery = "executeAdsQuery"
export const executeAdsRoFQuery = "executeAdsRoFQuery"
export const executeAdsExportQuery = "executeAdsExportQuery"
export const executeAdsRoFExport = "executeAdsRoFExport"
export const executeAdsCampaignReportQuery = "executeAdsCampaignReportQuery"
export const getAdsQuery = "getAdsQuery"
export const executeScheduleQuery = "executeScheduleAdsQuery";
export const getAdsProductClasses = "getAdsProductClasses"